module.exports = __webpack_public_path__ + "static/media/LoginCohete.24aacb55.png";